<label class="label {combo ? "combo" : ""}">Pick a flood size / chance </label>
<ul class="likelihood-options {combo ? "combo" : ""}">
  {#each options as { value, label, displayTooltip }, i}
    <li 
      class="likelihood-options-item {disabledLikelihood ? 'disabled' : ''}"
      id={`${value}_${i}`}
      on:click={() => selectFloodLikelihood(value, i)}
      title={displayTooltip}>
      <div class="likelihood-options-item-wrapper">
        <span class="likelihood-options-item-circle { selectedValue === value ? 'active' : ''}"></span>
        <span>{@html label}</span>
        <div class="flood-illustration {value}">
          <div class="flood-illustration-image-wrapper">
            <div class="flood-water"></div>
            <div class="flood-water"></div>
            <div class="flood-water"></div>
          </div>
        </div>
      </div>
    </li>
  {/each}
</ul>

<script>
import store from "../../../state";
import { FloodLikelihoodOptions } from "../../../services";
import { onMount } from "svelte/internal";
import utils from "../../../utils";
import storage from "../../../services/StorageService";
export let disabledLikelihood = false;
export let selectedValue = "";
export let combo = false;
export let suburb = "";
let options = FloodLikelihoodOptions;
const selectFloodLikelihood = (value, index) => {
    const selectedOptions = options[index];
    storage.setItem("ses-flood", selectedOptions.value);
    store.update(state => {
        state.selectedLikelihood = {
            label: selectedOptions.label,
            value: selectedOptions.value,
            tooltip: selectedOptions.tooltip
        };
        return state;
    });
};
const setTooltip = () => {
    options = FloodLikelihoodOptions.map(item => {
        return Object.assign(Object.assign({}, item), { displayTooltip: suburb === ""
                ? `A ${item.tooltip}`
                : `In ${utils.capitalize(suburb)}, a ${item.tooltip}` });
    });
};
onMount(() => {
    setTooltip();
});
$: {
    if (suburb) {
        setTooltip();
    }
}
</script>


<style>@-webkit-keyframes waveBottom{0%{background-position-x:0}to{background-position-x:350px}}@keyframes waveBottom{0%{background-position-x:0}to{background-position-x:350px}}@-webkit-keyframes waveMid{0%{background-position-x:0}to{background-position-x:-350px}}@keyframes waveMid{0%{background-position-x:0}to{background-position-x:-350px}}.label{font-weight:700;font-size:.875rem;line-height:19px}.label.combo{font-size:.813rem}.likelihood-options{display:flex;flex-wrap:wrap;flex-direction:column}.likelihood-options-item{margin:.344rem 0;border:1px solid #f08403;border-radius:.625rem;height:2.875rem;cursor:pointer;flex:0 1 2.875rem;font-size:.75rem;line-height:16px;color:#363636;position:relative;overflow:hidden}.likelihood-options-item:first-child{margin:0 0 .344rem}.likelihood-options-item-wrapper{padding:.875rem 0 .875rem .9375rem;display:flex;align-items:center}.likelihood-options-item-wrapper>*{z-index:1}.likelihood-options-item .flood-illustration{position:absolute;width:100%;height:100%;overflow:hidden;z-index:0;top:0;left:0}.likelihood-options-item .flood-illustration.very-high{top:60%}.likelihood-options-item .flood-illustration.high{top:50%}.likelihood-options-item .flood-illustration.medium{top:40%}.likelihood-options-item .flood-illustration.low{top:30%}.likelihood-options-item .flood-illustration-image-wrapper{position:relative;width:100%;height:100%;opacity:.25}.likelihood-options-item .flood-illustration-image-wrapper .flood-water{position:absolute;width:100%}.likelihood-options-item .flood-illustration-image-wrapper .flood-water:first-child{background:url(../../../assets/images/flood_level_bottom.png);height:20px;bottom:0;z-index:2;background-position:350px 20px;-webkit-animation:waveBottom 30s linear infinite;animation:waveBottom 30s linear infinite}.likelihood-options-item .flood-illustration-image-wrapper .flood-water:nth-child(2){background:url(../../../assets/images/flood_level_middle.png);bottom:7px;height:18px;z-index:1;background-position:350px 18px;-webkit-animation:waveMid 15s linear infinite;animation:waveMid 15s linear infinite;-webkit-animation-delay:-5s;animation-delay:-5s}.likelihood-options-item .flood-illustration-image-wrapper .flood-water:nth-child(3){background:url(../../../assets/images/flood_level_top.png);height:18px;bottom:18px;z-index:0;background-position:350px 18px;-webkit-animation:waveBottom 30s linear infinite;animation:waveBottom 30s linear infinite;-webkit-animation-delay:-2s;animation-delay:-2s}.likelihood-options-item.disabled{cursor:not-allowed;background-color:#f5f5f5;color:rgba(0,0,0,.5)}.likelihood-options-item.disabled .likelihood-options-item-circle{opacity:.5}.likelihood-options-item-circle{width:1.125rem;height:1.125rem;border-radius:1.125rem;display:block;margin-right:5px;flex:0 0 1.125rem;background-color:#fff;border:1px solid #9e9e9e}.likelihood-options-item-circle.active{background-color:#f08403}</style>
